import { connect } from "react-redux";
import CosParticipant from "./ParticipantList";

import {
  supportCoordinatorsRequest,
  getCosParticipantListRequest,
} from "../../../../store/actions/ah.actions";
import {
  getSupportCoordinator,
  getSupportCoordinatorLoader,
  getCosParticipant,
  getCosParticipantLoader,
} from "../../../../store/selector/ah.selector";
import { getSpSetting } from "../../../../store/selector/sp.selector";

const mapDispatchToProps = {
  getCosParticipant: getCosParticipantListRequest,
  getSupportCoordinators: supportCoordinatorsRequest,
};

const mapStateToProps = (state) => {
  const cosParticipant = getCosParticipant(state);
  const cosParticipantLoader = getCosParticipantLoader(state);

  const supportCoordinator = getSupportCoordinator(state);
  const supportCoordinatorLoader = getSupportCoordinatorLoader(state);
  const settings = getSpSetting(state);

  return {
    cosParticipant,
    cosParticipantLoader,
    supportCoordinator,
    supportCoordinatorLoader,
    settings,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CosParticipant);
